import { Col } from "react-bootstrap";
import {Button} from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from "classnames";

export default function ListBox(props) {
  
    let {ListData,onExploreAction } = props;

    let itName = ListData && ListData.name !== undefined && ListData.name !== null ? ListData.name : "";
    let itDesc = ListData && ListData.desc !== undefined && ListData.desc !== null ? ListData.desc : "";
    let image = ListData && ListData.image !== undefined && ListData.image !== null ? ListData.image : "";
    let crname = ListData && ListData.crname !== undefined && ListData.crname !== null ? ListData.crname : "";
    let btnText = ListData && ListData.btnText !== undefined && ListData.btnText !== null ? ListData.btnText : "";
    let itlist = ListData && ListData.list !== undefined && ListData.list !== null ? ListData.list : "";
    let type = ListData && ListData.type !== undefined && ListData.type !== null ? ListData.type : "";
    let clickBox = ListData && ListData.clickBox !== undefined && ListData.clickBox !== null ? ListData.clickBox : false;
    let url = ListData && ListData.url !== undefined && ListData.url !== null ? ListData.url : false;
    let ispopular = ListData && ListData.ispopular !== undefined && ListData.ispopular !== null ? ListData.ispopular : false;
    let isImage = true;
    let indexOfSearchString = image['icon'] !== undefined && image['icon'] !== null ? image['icon'].indexOf("fa-") : image.indexOf("fa-");
    if(indexOfSearchString !== -1){
        isImage = false
    }
    let serverUrl = process.env.REACT_APP_SERVER_URL;
    let customImageClass = "integration-product-image";

    if(image['icon'] !== undefined){
        customImageClass = "cloud-teley-image";
    }
    if(type == 'Custom_Forms'){
        customImageClass = "custom-form-image";
    }

    // image variable is url structure
    if(image['icon'] !== undefined){
        //image = image['icon'];
         image = serverUrl+"/Content/images/"+image['icon'];
    }else{
        image = image;
    }
    let isIframe = false;
    if(image.indexOf("pe-") === 0){
        // pe-7s-test
        isIframe = true;
    }

    return(
        <Col md={'4'} className={cx('padding-top-25', { "custom-form-list-box": type == 'Custom_Forms'})}>
            <div className={cx('integration-items listboxcontent handshadow mw-330',{" custom-form-box-container" : type == 'Custom_Forms'})} onClick={clickBox ? (e => {onExploreAction(e, crname, itDesc)}) : ""}>
                <span className={cx(ispopular ? "populartag" : "hide")}>Most Popular</span>
                
                <div className={'integration-product-box'}>
                    {
                        !isImage && 
                        <FontAwesomeIcon icon={image} size="2x" style={{color: "#30c384",}} />
                    }
                    {
                        isImage && !isIframe &&
                        <img src={image} className={customImageClass} />
                    }
                    {
                        isIframe &&
                        <i className={`nav-link-icon ${image} `}> </i>
                    }
                </div>
                <span className={'integration-name'}>{itName}</span>
                <div className={cx(itDesc == '' ? 'hide' : 'integration-desc',
                    {"custom-form-box custom-form-contant-align-center" : type == 'Custom_Forms'})}>
                    {itDesc}
                </div>
                {
                    <div  className="cloud-telephoney-list-table">
                        {
                            itlist &&
                            <th>
                                <bold>
                                    Supported Features
                                </bold>
                            </th>
                        }
                        
                        {
                            itlist &&
                            itlist.map((value, index) => {
                                return(
                                    <>
                                        <div>
                                            <tr>
                                                <td>
                                                    <span>
                                                        <FontAwesomeIcon icon={value['icon']} style={{color: "#3ad47d"}} />
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="integration-desc">
                                                        {value['list']}
                                                    </span>
                                                </td>
                                            </tr>
                                        </div>  
                                    </>
                                )
                            })
                        }
                    </div>
                }
                {
                    btnText !== "" &&
                    <Button outline onClick={(e) => {onExploreAction(e, crname, url)}} color={btnText !== "Disconnect" ? 'success' : 'secondary'} className={type == 'cloud_telephony' ? "cloud-telephone-btn" : ""} disabled={btnText == "Coming Soon!"}>
                        {btnText}
                    </Button>
                }
            </div>
        </Col>
    )
}
